export const SHIPPING_ADDRESS_CHANGE = 'shipping_address_change';
export const SHIPPING_METHOD_CHANGE = 'shipping_method_change';
export const CLOSE_WALLET = 'close_wallet';
export const PAYMENT_AUTHORIZED = 'payment_authorized';
export const NONCE = 'nonce';
export const ERROR = 'error';
export const READY = 'ready';
export const INVALID_PAYMENT_DATA = 'invalid_payment_data';
export const INVALID_SHIPPING_ADDRESS = 'invalid_shipping_address';
export const BUTTON_CLICK = 'wallet_button_click';
export const COUPON_CODE_CHANGE = 'coupon_code_change';
export const UNSERVICEABLE_ADDRESS = 'unserviceable_address';
